import React, { useId } from "react";
import Tabs from "../shared/Tabs";
import {
  CONNECTION_PROTOCOLS,
  CONNECTION_PROTOCOL_OPTIONS,
} from "./connectionProtocols";

const AgentConnectionSection = ({
  value,
  onChange,
  connectionDrafts,
  onConnectionDraftChange,
  children,
}) => {
  const id = useId();
  return (
    <div className="space-y-4">
      <Tabs options={CONNECTION_PROTOCOL_OPTIONS} value={value} onChange={onChange} label="Connection type" idPrefix={id} />
      <div
        role="tabpanel"
        id={`${id}-mcp-panel`}
        aria-labelledby={`${id}-mcp-tab`}
        hidden={value !== "mcp"}
      >
        <p className="text-xs text-ink-gray-500 dark:text-ink-gray-400 mb-4">
          Where this agent's MCP server lives and how Photon authenticates to it. Saved into policy.json.
        </p>
        {children}
      </div>
      {CONNECTION_PROTOCOLS.filter(({ Panel }) => Panel).map((protocol) => {
        const ProtocolPanel = protocol.Panel;
        return (
          <div
            key={protocol.value}
            role="tabpanel"
            id={`${id}-${protocol.value}-panel`}
            aria-labelledby={`${id}-${protocol.value}-tab`}
            hidden={value !== protocol.value}
          >
            <ProtocolPanel
              value={connectionDrafts?.[protocol.value]}
              onChange={onConnectionDraftChange
                ? (draft) => onConnectionDraftChange(protocol.value, draft)
                : undefined}
            />
          </div>
        );
      })}
    </div>
  );
};

export default AgentConnectionSection;
